export default {
  calibration: state => state.calibration,
  stepStatus: state => state.stepStatus,
  aimingUrls: state => state.aimingUrls,
  alignmentSpecs: state => state.alignmentSpecs
}



// WEBPACK FOOTER //
// ./src/store/modules/calibration/getters.js